import { config } from '../config'

const baseUrl = config.apiurl;
const fileUrl = config.fileurl;

// const baseUrl = 'http://localhost:50061/api'
// const fileUrl = 'http://localhost:50061/'

export const API_ENDPOINTS = {
  FILE_URL: fileUrl,
  // Header
  GET_TODAY_RATES: `${baseUrl}/rates/getrate`,
  // Home
  GET_BANNER: `${baseUrl}/sliders/getslider`,
  GET_DELIVERY_PROCESS: `${baseUrl}/optionlist/get_optionlist`,
  GET_SHOP_BY_CATEGOTY: `${baseUrl}/shopbycat/`,
  GET_ABOUT: `${baseUrl}/aboutus/get_about`,
  GET_TRYON: `${baseUrl}/tryonlists/get_tryon`,
  GET_TESTIMONIALS: `${baseUrl}/testlist/get_test`,
  GET_LATEST_PRODUCTS: `${baseUrl}/latestproducts/getprolist`,
  GET_CONTACT_DETAIL: `${baseUrl}/contact/get_contact`,

  // Products
  GET_MAIN_CATEGORY: `${baseUrl}/category/getcategory`,
  GET_SUB_CATEGORY: `${baseUrl}/subcategory/:id`,
  PRODUCTS_LIST: `${baseUrl}/product/getproductlist`,
  GET_PRODUCT: `${baseUrl}/product/:id`,
  GET_PRODUCT_STYLE: `${baseUrl}/prostyle/bySubCatgory/sub/:id`,
  GET_OCASSION_LIST: `${baseUrl}/occasionlist/getocclist`,
  GET_PURITY_LIST: `${baseUrl}/purity/getpuritylist`,
  GET_WEIGHT_RANGE_LIST: `${baseUrl}/weightrange`,
  GET_GENDER_LIST: `${baseUrl}/genderlist`,
  GET_WASTAGE_LIST: `${baseUrl}/wastages`,
  SEARCH_OPTIONS: `${baseUrl}/product/searchOptions`,
  SEARCH_PRODUCTS: `${baseUrl}/product/search`,

  // Appointment
  GET_TIME_SLOTS: `${baseUrl}/timeslot/gettime`,
  SAVE_APPOINTMENT: `${baseUrl}/schedules/createappt`,

  // About us
  GET_ABOUT_US: `${baseUrl}/aboutus/get_about`,

  // Contact us
  SEND_CONTACT: `${baseUrl}/contactus/add`,
  GET_METAL_TYPES: `${baseUrl}/category/getcategory`,
  SEND_CUSTOM_REQUEST: `${baseUrl}/customreq/create`,

  // Image upload
  MULTI_IMAGE_UPLOAD: `${baseUrl}/upload/upload-multiple`,
}

export const ACTION_TYPES = {
  SHOW_SNACKBAR: 'SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'HIDE_SNACKBAR',
  SHOW_LOADER: 'SHOW_LOADER',
  HIDE_LOADER: 'HIDE_LOADER',
  AUTH: 'AUTH',
  MENU_TOGGLE: 'MENU_TOGGLE',
  CONTACT_DETAILS: 'CONTACT_DETAILS',
}

export const CONS = {}
